/**
 * Shared label | value cell styles for responsive “stacked card” tables (mobile &lt; md).
 * Use with Executives-style cards: grid of two columns per row.
 */
export const MOBILE_LV_LABEL_CLASS =
  "px-2.5 py-2.5 text-[10px] sm:text-xs font-semibold uppercase tracking-wide text-[#201F1E] bg-[#E8F5E9] border-b border-r border-gray-200 flex items-center";

export const MOBILE_LV_VALUE_CLASS =
  "py-2.5 pl-4 pr-3 sm:pl-5 sm:pr-4 text-sm text-[#201F1E] bg-[#E3F2FD] border-b border-gray-200 min-w-0 break-words text-left border-r-0";

/** Outer card (one record) */
export const MOBILE_LV_CARD_CLASS =
  "rounded-md border-2 border-[#201F1E] overflow-hidden bg-white shadow-sm";

/** Two-column grid: label column ~42%, value column flexible */
export const MOBILE_LV_GRID_CLASS = "grid grid-cols-[minmax(0,42%)_1fr]";

/** Last label cell in a card (no bottom border) */
export const MOBILE_LV_LABEL_LAST = " border-b-0";

/** Last value cell in a card */
export const MOBILE_LV_VALUE_LAST = " border-b-0 border-r-0";
